module.exports = __webpack_public_path__ + "static/img/2.675a6335.png";